export const AUTH_TOKEN = "auth_token"
export const REF_TOKEN = "ref_token"
